__turbopack_context__.v({
  "footer": "CartFooter-module-scss-module__Gw0v3a__footer",
  "footerButtons": "CartFooter-module-scss-module__Gw0v3a__footerButtons",
  "footerTotalBreakdown": "CartFooter-module-scss-module__Gw0v3a__footerTotalBreakdown",
  "footerTotalCount": "CartFooter-module-scss-module__Gw0v3a__footerTotalCount",
  "footerTotalRow": "CartFooter-module-scss-module__Gw0v3a__footerTotalRow",
});
